import React, { useState } from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from "react-bootstrap/Button";

function SettingsDelete() {
const [show, setShow] = useState(false);
const handleClose = () => setShow(false);
const handleShow = () => setShow(true);

    return (
  <div className="text-center">
    <Button variant="primary" onClick={handleShow}>
      Delete Account
    </Button>

    <Modal centered show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Account Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>Please confirm your account deletion, this cannot be undone</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        {/* add delete button here and call handler that will delete and also perform handleClose */}
        <Button variant="primary" onClick={handleClose}>
          Delete Account
        </Button>
      </Modal.Footer>
    </Modal>
  </div>
);
}
        

export default SettingsDelete
